import { literal, object, type InferOutput } from 'valibot'
import { deepClone } from '../../../../../deep_clone'
import Unexpected from '../../../../../Exception/Unexpected.class'
import { Engine } from '../../../../engine/Engine.type'
import { HorizontalOrVertical, HorizontalOrVerticalSchema } from '../../../../entity/EntityHeading/HorizontalOrVertical.enum'
import { TilePositionXYSchema, type TilePositionXY } from '../../../../tile_position_xy/TilePositionXY.type'
import { randomId } from '../../../../util/rand'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const RownipulatorDuplicateRowActionSchema = object({
  type: literal(ActionType.Map.RownipulatorDuplicateRow),
  position: TilePositionXYSchema,
  orientation: HorizontalOrVerticalSchema,
})

export type RownipulatorDuplicateRowAction = InferOutput<typeof RownipulatorDuplicateRowActionSchema>

export function createRownipulatorDuplicateRowAction(position: TilePositionXY, orientation: HorizontalOrVertical): RownipulatorDuplicateRowAction {
  return {
    type: ActionType.Map.RownipulatorDuplicateRow,
    position,
    orientation,
  }
}

export async function handleRownipulatorDuplicateRowAction(
  engine: Engine,
  action: RownipulatorDuplicateRowAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  const { position, orientation } = action
  const { state } = engine
  const { ents, rng } = state

  // const playerId: Nullable<PlayerId> = 0

  if (orientation === HorizontalOrVertical.Horizontal) {
    const y = position.y

    // Increase map height and shift entities below the row down
    state.height += 1
    for (const ent of ents) {
      if (ent.y > y) {
        ent.y += 1
        ent.id = randomId(ents, rng)
      }
    }

    // Find and duplicate entities in the row at y
    const rowEnts = ents.filter(ent => ent.y === y)
    for (const original of rowEnts) {
      const copy = {
        ...deepClone(original),
        id: randomId(ents, rng),
        x: original.x,
        y: y + 1,
      }

      ents.push(copy)
    }

  } else if (orientation === HorizontalOrVertical.Vertical) {
    const x = position.x

    // Increase map width and shift entities to the right of the column
    state.width += 1
    for (const ent of ents) {
      if (ent.x > x) {
        ent.x += 1
        ent.id = randomId(ents, rng)
      }
    }

    // Find and duplicate entities in the column at x
    const columnEnts = ents.filter(ent => ent.x === x)
    for (const original of columnEnts) {
      const copy = {
        ...deepClone(original),
        id: randomId(ents, rng),
        x: x + 1,
        y: original.y,
      }

      ents.push(copy)
    }

  } else {
    throw new Unexpected('Invalid orientation in duplicate row action')
  }
}
